// Para desenvolvimento, usando mock - trocar pela API real em produção
import api from './api';
import { Perfil, Acesso } from '../types/perfil/Perfil';

class PerfilService {

  async buscarTodos(): Promise<Perfil[]> {
    const response = await api.get(`/api/perfil`);
    return response.data as Perfil[];
  }

  async buscarPorId(guid: string): Promise<Perfil> {
    const response = await api.get(`/api/perfil/${guid}`);
    return response.data as Perfil;
  }

  async criar(perfil: Perfil): Promise<Perfil> {
    const response = await api.post(`/api/perfil`, perfil);
    return response.data as Perfil;
  }

  async atualizar(guid: string, perfil: Perfil): Promise<Perfil> {
    const payload = { ...perfil, guid } as Perfil;
    const response = await api.put(`/api/perfil`, payload);
    return response.data as Perfil;
  }

  async excluir(guid: string): Promise<void> {
    await api.delete(`/api/perfil/${guid}`);
  }

  async buscarPerfisAtivos(): Promise<Perfil[]> {
    const response = await api.get(`/api/perfil/ativos`);
    return response.data as Perfil[];
  }

  async verificarAcesso(perfilGuid: string, tela: string): Promise<Acesso | null> {
    try {
      const response = await api.get(`/api/perfil/${perfilGuid}/acesso/${tela}`);
      return response.data as Acesso;
    } catch (err: any) {
      if (err.response && err.response.status === 404) return null;
      throw err;
    }
  }

  async duplicarPerfil(guid: string, novoNome: string): Promise<Perfil> {
    const response = await api.post(`/api/perfil/${guid}/duplicar`, { nome: novoNome });
    return response.data as Perfil;
  }

  async buscarPerfilDoUsuario(userGuid: string): Promise<Perfil | null> {
    try {
      const response = await api.get(`/api/usuarios/${userGuid}/perfil`);
      return response.data as Perfil;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async buscarPerfilDoUsuarioAtual(): Promise<Perfil | null> {
    try {
      const response = await api.get(`/api/usuarios/me/perfil`);
      return response.data as Perfil;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async buscarMenusPermitidos(): Promise<string[]> {
    try {
      const response = await api.get(`/api/perfil/menus-permitidos`);
      return response.data as string[];
    } catch (error: any) {
      console.error('Erro ao buscar menus permitidos:', error);
      return [];
    }
  }
}

export const perfilService = new PerfilService();
